/**
 * @module:  任务编辑
 * @author: Liang Huang 
 * @date: 2019-12-02 09:49:56 
 */

import { observable } from 'mobx';
import { ICheckModule, ICheckItem } from '@src/entity/company/task';
class TaskEdit {
  /**
   * 临时检查项
   */
  @observable tempCheckModule: ICheckModule | null = null;
  /**
   * 子检查项创建时检查模块
   */
  @observable createSubModule: ICheckModule | null = null;
  /**
   * 是创建:1 or 编辑子检查项: 2
   */
  @observable createOrEditSub: number = -1;
  /**
   * 当前子检查项数据
   */
  @observable curSubCheck: ICheckItem | null = null;
}
export default TaskEdit;
